import * as api from '../api/index'

import { ADD_NEW, UPDATE, DELETE, GET_INVOICE, FETCH_INVOICE_BY_USER, START_LOADING, END_LOADING } from './constants'

// export const getInvoices = () => async (dispatch)=> {
//     try {
//         const { data } = await api.fetchInvoices()
//         dispatch({ type: FETCH_ALL, payload: data })
//     } catch (error) {
//         console.log(error)
//     }
// }

export const getInvoicesByUser =(searchQuery) => async (dispatch) => {
    try {
      //dispatch({ type: START_LOADING })
      const  {  data  } = await api.fetchInvoicesByUser(searchQuery);
      dispatch({ type: FETCH_INVOICE_BY_USER, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)
      
    }
  }


export const getInvoice = (id) => async (dispatch)=> {

    
    try {
        const { data } = await api.fetchInvoice(id)
        const invoiceData = {...data}
        // console.log(invoiceData)
        dispatch({ type: GET_INVOICE, payload:  data.results[0]    })
    } catch (error) {
        console.log(error.response)
    }
}

export const createInvoice =(invoice, history ,openSnackbar) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.addInvoice(invoice);
        dispatch({ type: ADD_NEW, payload: data });
        openSnackbar("Invoice added successfully");
        dispatch({ type: END_LOADING })
        history.push(`/invoices`);
    } catch (error) {
        console.log(error)
    }
}

export const updateInvoice =(invoice, history, openSnackbar) => async (dispatch) => {

    try {
        const { data } = await api.updateInvoice(invoice)
        dispatch({ type: UPDATE, payload: data })
        openSnackbar("Invoice updated successfully")
        history.push(`/invoices`)
    } catch (error) {
        console.log(error)
    }
}

export const deleteInvoice =(id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteInvoice(id)

        dispatch({type: DELETE, payload: id})
        openSnackbar("Invoice deleted successfully")
    } catch (error) {
        console.log(error.response)
    }
}